import React from 'react';
import { Route } from 'react-router-dom';
import ClientPrivacyPolicyPage from './app/privacy/PrivacyPolicyPage';
import ClientTermsAndPaymentPage from './app/privacy/TermsAndPaymentPage';

const pageRoutes = (
  <>
    <Route path="privacy" element={<ClientPrivacyPolicyPage />} />
    <Route path="terms" element={<ClientTermsAndPaymentPage />} />
  </>
);

export default pageRoutes;
